export default {
  MOUNTED: 'mounted',
  PLAY_BOOK: 'playBook',
  ERROR: 'metablockError',
  UPDATED_BOOK: 'updatedBook',
  ADD_TO_FAVORITES: 'addToFavourites',
  EDIT: 'edit'
};
